<!-- <input type="radio" id="ticket-type-{{inputId}}" [value]="value" hidden (click)="onSelectChange()"> -->
<label for="ticket-type-{{inputId}}" [class.active]="isActive" role="button">
    <svg xmlns="http://www.w3.org/2000/svg" width="80" viewBox="0 0 112.81 93.98">
        <path d="M104.65,107H15.35A11.78,11.78,0,0,1,3.59,95.24v-9.4a2.35,2.35,0,0,1,2.35-2.35H8.29a9.4,9.4,0,1,0,0-18.8H5.94a2.35,2.35,0,0,1-2.35-2.35h0v-9.4A11.78,11.78,0,0,1,15.35,41.18h89.3a11.78,11.78,0,0,1,11.76,11.75v9.4a2.35,2.35,0,0,1-2.35,2.35h-2.35a9.4,9.4,0,1,0,0,18.8h2.35a2.35,2.35,0,0,1,2.35,2.35v9.4A11.77,11.77,0,0,1,104.65,107ZM8.29,88.19v7a7.07,7.07,0,0,0,7.06,7.05h89.3a7.07,7.07,0,0,0,7.06-7.05v-7h0a14.1,14.1,0,1,1,0-28.2V52.93a7.07,7.07,0,0,0-7.06-7H15.35a7.06,7.06,0,0,0-7.06,7v7a14.1,14.1,0,0,1,0,28.2Z" transform="translate(-3.59 -13.01)" [style.fill]="color"/>
        <path d="M15.34,45.88a2.35,2.35,0,0,1-.83-4.55L89.25,13.42a7.2,7.2,0,0,1,9.15,4.34l8.47,25a2.35,2.35,0,0,1-4.42,1.61l0-.1-8.48-25a2.4,2.4,0,0,0-3-1.44L16.16,45.73a2.29,2.29,0,0,1-.82.15Z" transform="translate(-3.59 -13.01)" [style.fill]="color"/>
        <g>
            <text [ngStyle]="{
                'isolation': 'isolate',
                'font-size': 18,
                'font-family': 'OpenSans, khmerOS-btb',
                'font-weight': 700,
                'fill': textColor
            }" x="50%" y="67%" dominant-baseline="middle" text-anchor="middle">
            {{ type }} {{( type > 1 ? 'LABEL.DAYS' : 'LABEL.DAY') | translate }}
            </text>
        </g>
    </svg>
    <p class="ae-price">{{ price | currency }}</p>
</label>

<!-- <div class="card">
    <span for="title">{{ type }} {{ type > 1 ? 'Days' : 'Day' }}</span>
    <button>{{ price | currency }}</button>
</div> -->
